const API_BASE_PATH = process.env.REACT_APP_BASE_URL;
const BASE_URL = `${API_BASE_PATH}/api/v1`;

// ✅ Configurable via env, fallback to 100
export const DEFAULT_PAGE_LIMIT = process.env.REACT_APP_DEFAULT_PAGE_LIMIT
    ? parseInt(process.env.REACT_APP_DEFAULT_PAGE_LIMIT, 10)
    : 100;

// Contracts
export const CONTRACTS_URL = (dataProviderId, limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') => {
    let url = `${BASE_URL}/contracts?limit=${limit}&offset=${offset}&dataProviderID=${dataProviderId}`;
    if (search.trim()) {
        url += `&search=${encodeURIComponent(search)}`;
    }
    return url;
};

// Datasets
export const DATASETS_URL = (contractId, limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') => {
    let url = `${BASE_URL}/datasets?limit=${limit}&offset=${offset}&contractID=${contractId}`;
    if (search && search.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`;
    }
    return url;
};

// Dataset by ID
export const DATASET_BY_ID_URL = (datasetId) => `${BASE_URL}/datasets/${datasetId}`;

// Create Dataset
export const CREATE_DATASET_URL = `${BASE_URL}/datasets`;

// Dataset Complete
export const DATASET_COMPLETE_URL = (datasetId) => `${BASE_URL}/datasets/${datasetId}/complete`;

// Dataset Abort
export const DATASET_ABORT_URL = (datasetId) => `${BASE_URL}/datasets/${datasetId}/abort`;

// Dataset files/contents
export const DATASET_CONTENTS_URL = (datasetId, path = '/', limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') => {
    const url = new URL(`${BASE_URL}/datasets/files/${datasetId}`);
    url.searchParams.append('path', path);
    url.searchParams.append('limit', limit.toString());
    url.searchParams.append('offset', offset.toString());
    if (search) {
        url.searchParams.append('search', search);
    }
    return url.toString();
};

// Uploads
export const UPLOADS_URL = `${BASE_URL}/uploads`;
export const UPLOAD_START_URL = `${BASE_URL}/uploads/start`;
export const UPLOAD_COMPLETE_URL = (uploadId) => `${BASE_URL}/uploads/${uploadId}/complete`;
export const UPLOAD_BATCH_COMPLETE_URL = `${BASE_URL}/uploads/complete`;
export const CONFIG_URL = `${BASE_URL}/uploads/configs`;